
<h1 mat-dialog-title *ngIf="this.Dialogdata">{{ (GeneratedDoc$ | async)?.Name || '' }}</h1>
<mat-dialog-content>
    <ng-container *ngIf="GeneratedDoc$ | async; else loading">
        <ng-container *ngIf="EditFormFields; else editorTemplate">
            <mat-tab-group *ngIf="BS.MobileQuery | async" [preserveContent]="false" mat-align-tabs="center" (selectedTabChange)="selectedTabChange($event)">
                <mat-tab label="Schreiben" style="padding: 0.5rem">
                    <ng-container [ngTemplateOutlet]="formsTemplate" [ngTemplateOutletContext]="{smallHeight: true}"></ng-container>
                </mat-tab>
                <mat-tab label="Bericht" style="display: flex" >
                    <ng-container [ngTemplateOutlet]="editorTemplate"></ng-container>
                </mat-tab>
            </mat-tab-group>
            <ng-container *ngIf="!(BS.MobileQuery | async)">
<!--                <div class="flex-wrapper">-->
<!--                    <ng-container [ngTemplateOutlet]="formsTemplate"></ng-container>-->
<!--                    <mat-divider vertical></mat-divider>-->
<!--                    <ng-container [ngTemplateOutlet]="editorTemplate"></ng-container>-->
<!--                </div>-->
                <app-detail-view-template class="no-scroll" [ShowButtons]="false"  [ShowPlaceholder]="false" [Resizable]="true" (AfterResize)="resizeEditor()" [backgroundColor]="Dialogdata ? 'card' : 'default'">
                    <ng-container *appDetailViewLeftContent><ng-container [ngTemplateOutlet]="formsTemplate"></ng-container></ng-container>
                    <ng-container *appDetailViewRightContent><ng-container [ngTemplateOutlet]="editorTemplate"></ng-container></ng-container>
                </app-detail-view-template>
            </ng-container>
        </ng-container>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions *ngIf="this.Dialogdata">
    <button app-button Color="cancel" Inverted (click)="CloseDialog()">abbrechen</button>
    <!--    <button app-button (click)="editFormControlClick()">formcontrolmode</button>-->
    <button app-button Color="green" (click)="SaveClick()" [Disabled]="!(EditorContentDirty$ | async) && !GeneratedDocumentForm.dirty || GeneratedDocumentForm.invalid">speichern</button>
</mat-dialog-actions>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>

<ng-template #formsTemplate let-smallHeight="smallHeight">
    <div class="forms-wrapper" [class.scrollbar]="smallHeight" [class.p05]="smallHeight">
        <div class="routing-buttons" *ngIf="GeneratedDoc$ | async as doc">
            <h1 class="mat-headline-6" *ngIf="!this.Dialogdata">{{ doc?.Name || '' }}</h1>
            <app-go-to-button (click)="CloseDialog()" *ngIf="doc.CommissionId" EntityType="commission" [EntityId]="doc.CommissionId"></app-go-to-button>
            <app-go-to-button (click)="CloseDialog()" *ngIf="doc.CustomerId" EntityType="customer" [EntityId]="doc.CustomerId"></app-go-to-button>
            <app-go-to-button (click)="CloseDialog()" *ngIf="Dialogdata" EntityType="generatedDocument" [EntityId]="doc.Id"></app-go-to-button>
            <!--        todo hier popup öffnen-->
            <button app-round-button *ngIf="doc.DocumentIdFromPdf" (click)="OpenFilePreviewClick(doc.DocumentIdFromPdf)"><fa-icon [icon]="DMSPageMeta.Icon"></fa-icon></button>
<!--            <app-go-to-button (click)="CloseDialog()" *ngIf="doc.DocumentIdFromPdf" EntityType="file" [EntityId]="doc.DocumentIdFromPdf"></app-go-to-button>-->
            <ng-container *ngIf="BS.MobileQuery | async" [ngTemplateOutlet]="stateTemplate"></ng-container>
        </div>
        <ng-container *ngIf="ShowGeneratedDocumentData">
            <div class="flex-row">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h3>Bericht</h3>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-detail-list-template
                        [Inline]="true"
                        [Editing]="true"
                        [Data]="nameDetailListTemplateData"
                    ></app-detail-list-template>
                </mat-expansion-panel>
                <mat-expansion-panel *ngIf="zuordnungDetailListTemplateData$ | async as listData">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h3>Zuordnung</h3>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-detail-list-template [Inline]="true" [Editing]="true"
                                              [Data]="listData"></app-detail-list-template>
                </mat-expansion-panel>
                <mat-expansion-panel *ngIf="this.GeneratedDocumentForm.controls.Commission.value">
                    <mat-expansion-panel-header>
                        <h3>Unterschrift</h3>
                    </mat-expansion-panel-header>
                    <div class="flex flex-col">
                        <h3>Unterschrift des Kunden</h3>
                        <div style="position: relative;width: 24rem;height: 12rem;margin-right: auto;">
                            <div style="position: absolute; top: 0.5rem; left: 0.5rem;" class="flex gap-2">
                                <button app-round-button
                                        (click)="logoUpload.click()" matTooltip="Bild hochladen">
                                    <fa-icon icon="upload"></fa-icon>
                                </button>
                                <button *ngIf="CustomerSignatureFromCommission$ | async as signatureFile" app-round-button
                                        (click)="editorComponent.InsertSignature(signatureFile)" matTooltip="Unterschrift einfügen">
                                    <fa-icon icon="arrow-right-to-bracket"></fa-icon>
                                </button>
                            </div>
                            <img
                                #image
                                *ngIf="CustomerSignatureFromCommission$ | async"
                                style="max-height: 100%;max-width: 100%;"
                                [src]="CustomerSignatureFromCommissionDownloadPath$ | async"
                                alt="Unterschrift"
                            />
                            <div
                                *ngIf="!(CustomerSignatureFromCommission$ | async)"
                                style="
                                        width: 20rem;
                                        height: 10rem;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        flex-direction: column;
                                        border-radius: 4px;
                                        background-color: rgba(0, 0, 0, 0.15);
                                    "
                            >
                                <fa-icon icon="signature" size="3x"></fa-icon>
                                <h2 style="margin: 0">Unterschrift</h2>
                            </div>
                            <input type="file" accept="image/*" hidden #logoUpload
                                   (change)="changeCommissionSignature($event)"/>
                        </div>
                    </div>
                </mat-expansion-panel>
            </div>
            <mat-divider></mat-divider>
        </ng-container>
        <p *ngIf="FormsInitialised && CustomFields?.length === 0">Keine Felder zum ausfüllen vorhanden</p>
        <app-custom-form-fields-modal [class.scrollbar]="!smallHeight" [CustomFields]="CustomFields" [CustomFieldsModalTemplates]="(GeneratedDoc$ | async)?.AdditionalData?.CustomFieldsModalTemplates || []" DefaultAlignment="row"></app-custom-form-fields-modal>
    </div>
</ng-template>
<ng-template #editorTemplate>
    <div class="editor-wrapper">
        <app-burger-button-wrapper #burgerButtonWrapperComponent class="editor-buttons">
            <ng-container [ngTemplateOutlet]="stateTemplate"></ng-container>
<!--            <button app-round-button><fa-icon icon="info"></fa-icon></button>-->
            <button app-round-button aria-label="Unterschreiben" matTooltip="Unterschreiben" [IsLoading]="LoadingService.IsLoading$ | async" (click)="SignatureClick()"><fa-icon icon="signature"></fa-icon></button>
            <button app-round-button aria-label="Hochladen" matTooltip="Hochladen" *ngIf="!editorComponent?.DocumentEditorContainer?.documentEditor?.editor?.documentHelper.isDocumentProtected" (click)="FileUploadClick()"><fa-icon icon="upload"></fa-icon></button>
            <button app-round-button aria-label="Herunterladen" matTooltip="Herunterladen" [IsLoading]="LoadingService.IsLoading$ | async" [mat-menu-trigger-for]="downloadMenu"><fa-icon icon="download"></fa-icon></button>
            <button app-round-button aria-label="Schreibschutz" matTooltip="Schreibschutz" (click)="RestrictEditingClick()" [Disabled]="(PreventEditing$ | async) || (BS.TouchQuery | async)"><fa-icon [icon]="editorComponent?.DocumentEditorContainer?.documentEditor?.editor?.documentHelper.isDocumentProtected ? 'lock-open' : 'lock'"></fa-icon></button>
            <button app-round-button aria-label="Email senden" matTooltip="Email senden" [IsLoading]="LoadingService.IsLoading$ | async" (click)="SendEmailClick()"><fa-icon icon="paper-plane"></fa-icon></button>
            <button app-round-button aria-label="Speichern" matTooltip="Speichern" [IsLoading]="LoadingService.IsLoading$ | async" (click)="SaveClick()" *ngIf="!Dialogdata" [Disabled]="!(EditorContentDirty$ | async) && !GeneratedDocumentForm.dirty || GeneratedDocumentForm.invalid" Color="green"><fa-icon icon="save"></fa-icon></button>
            <button app-round-button aria-label="Löschen" matTooltip="Löschen" [IsLoading]="LoadingService.IsLoading$ | async" (click)="DeleteClick()" Color="red"><fa-icon icon="trash"></fa-icon></button>
        </app-burger-button-wrapper>
        <app-document-editor
            *ngIf="GeneratedDoc$ | async as doc"
            [RestrictEditing]="false"
            [EnableToolbar]="false"
            [Filename]="doc.Name"
            [ToolbarItems]="EditorToolbarItems"
            [EnableAutoFocus]="false"
            #editor
            (OnCreated)="EditorCreated$.next(true)"
            (ContentChange)="EditorContentChange($event)"
        ></app-document-editor>
    </div>
</ng-template>
<mat-menu #downloadMenu="matMenu">
    <a *ngIf="PdfFilePath$ | async as url" mat-menu-item matTooltip="pdf Datei herunterladen" [href]="url" [download]="(PdfFile$ | async)?.Name"><fa-icon icon="file-pdf"></fa-icon> pdf</a>
    <button *ngIf="!(PdfFilePath$ | async)" mat-menu-item matTooltip="pdf herunterladen" (click)="DownloadPdfClick()"><fa-icon icon="file-pdf"></fa-icon> pdf</button>
    <button mat-menu-item matTooltip="Word Datei herunterladen" (click)="DownloadDocxClick()"><fa-icon icon="file-word"></fa-icon> docx</button>
</mat-menu>
<ng-template #stateTemplate>
    <div class="state-wrapper">
        <fa-icon icon="info" size="lg"></fa-icon>
        <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select [formControl]="GeneratedDocumentForm.controls.State">
                <mat-option *ngFor="let s of States" [value]="s.value">
                    {{s.label}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>
